import * as React from 'react';
import { Button } from 'antd';
import { getPropagationDisplay } from './Tag';

export interface PropagationButtonProps extends GetProps<typeof Button> {
  children?: Propagation;
}

export const PropagationButton = (props: PropagationButtonProps) => {
  const { children = 'context', ...p } = props;

  return <Button {...p}>{getPropagationDisplay(children)}</Button>;
};
